<!--  -->
<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>精彩活动</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>
    <!-- 主体 -->
    <div class="box-con">
      <div class="flex-box">
        <div class="left" :class="{ 'is-disabled': num === 1 }">
          <div style="font-size: 16px; color: #409eff ; margin-bottom: 30px">
            广告推广购买
          </div>
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            label-width="100px"
            label-suffix="："
            :rules="rules"
            style="margin-left: 30px"
          >
            <el-form-item
              label="推广方式"
              prop="TXurl"
              :required="true"
              :errorType="'toast'"
            >
              <div class="flex-box" style="width: 420px">
                <div
                  :class="
                    isIndex == 0 ? 'change-box change-box-active' : 'change-box'
                  "
                  @click="handleMediaTypeChange(0)"
                >
                  海报推广
                </div>
                <div
                  :class="
                    isIndex == 1 ? 'change-box change-box-active' : 'change-box'
                  "
                  @click="handleMediaTypeChange(1)"
                >
                  视频推广
                </div>
              </div>
              <div class="upload-box">
                <div class="container firm-clickable" v-loading="loading1"  @click="clickFile()">
                  <img
                    :src="ruleForm.TXurl"
                    alt=""
                    v-if="ruleForm.TXurl != '' && isIndex == 0"
                  />
                  <!-- 绑定视频地址 -->
                  <!-- 显示原生播放控制条（必加，否则无播放按钮） -->
                  <!-- 视频宽度，也可通过css设置 -->
                  <!-- 高度自适应，保持比例 -->
                  <!-- 可选：视频封面图地址（未播放时显示） -->
                  <!-- 可选：预加载视频元信息（封面/时长），不加载完整视频，优化性能 -->
                  <video
                    :src="ruleForm.TXurl"
                    controls
                    width="190px"
                    height="auto"
                    :poster="ruleForm.TXurl"
                    preload="metadata"
                    v-if="ruleForm.TXurl != '' && isIndex == 1"
                  ></video>
                  <input
                    type="file"
                    ref="clearFile"
                    @change="onFileChange"
                    id="file"
                  />
                  <input
                    type="button"
                    value="+"
                    class="btn"
                    v-if="ruleForm.TXurl == ''"
                  />
                </div>
                <div
                  style="
                    font-size: 10px;
                    color: #999;
                    text-align: center;
                    width: 320px;
                    line-height: 15px;
                    margin: 15px auto 0;
                  "
                >
                  {{
                    isIndex == 0
                      ? "支持JPG、PNG格式，大小不得超过10M，启动页建议比例为:9:16，首页建议比例为16:9，可联系客服进行专业设计"
                      : "支持MP4、ANI、MKV、WMV、MPEG格式，大小不得超过100M，可联系客服进行专业设计"
                  }}
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="推广途径"
              prop="route"
              :required="true"
              :errorType="'toast'"
            >
              <el-select
                placeholder="请选择"
                style="width: 420px"
                v-model="ruleForm.route"
                @change="handleRouteChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推广次数">
              <div class="flex-box" style="width: 420px">
                <div
                  v-for="(item, index) in numList"
                  :key="index"
                  :class="
                    textIndex == item.number
                      ? 'text-box text-box-active'
                      : 'text-box'
                  "
                  @click="textChange(item, index)"
                >
                  {{ item.number }} <span v-if="item.number != '其他'">次</span>
                </div>

                <el-form-item prop="quantity" v-if="textIndex == '其他'">
                  <el-input
                    v-model="ruleForm.quantity"
                    :placeholder="`请输入次数（最少${leastBuyNumber}以上）`"
                    size="small"
                    style="width: 320px; margin-top: 10px"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
          </el-form>
          <div class="flex-box">
            <div style="font-size: 12px; color: #666">
            </div>
            <div>
              <el-button
                type="primary"
                style="width: 100px"
                @click="handelPrice('ruleForm')"
                >计算价格</el-button
              >
            </div>
          </div>
        </div>
        <div class="right" :class="{ 'is-disabled': num === 0 }">
          <div style="font-size: 16px; color: #409eff ; text-align: center">
            付款信息
          </div>
          <!-- <p style="font-size: 12px; color: #999;">11</p> -->
          <div style="width: 320px; margin: 40px auto; font-size: 12px">
            <div class="Content">
              <p class="title-p">
                广告推广({{ isIndex == 0 ? "海报" : "视频" }})：
              </p>
              <div class="Content-box">
                <p style="color: red">{{ dataObj.amount }}元</p>
              </div>
            </div>

            <div class="Content">
              <p class="title-p">推广次数：</p>
              <div class="Content-box">
                <p>{{ dataObj.count }}次</p>
              </div>
            </div>
            <div class="Content">
              <p class="title-p">侦迹币数量：</p>
              <div class="Content-box">
                <!-- 侦迹币冻结，展示已冻结提示 -->
                <p>
                  {{ dataObj.companyTraceCoin
                  }}<span style="margin-left: 10px" v-if="accountStatus == '0'"
                    >(已冻结)</span
                  >
                </p>
              </div>
            </div>
            <div class="Content">
              <p class="title-p">使用侦迹币抵扣：</p>
              <!-- 侦迹币为0或被冻结时无法选择侦迹币抵扣 -->
              <el-checkbox
                v-model="checked"
                v-if="dataObj.companyTraceCoin <= 0 || accountStatus == '0'"
                @change="handelChange"
                disabled
              ></el-checkbox>
              <!-- 正常抵扣 -->
              <el-checkbox
                v-model="checked"
                v-else
                @change="handelChange"
              ></el-checkbox>
              <p style="margin-left: 10px">
                减
                <span style="color: red"
                  >{{
                    dataObj.companyTraceCoin >= dataObj.amount
                      ? dataObj.amount
                      : dataObj.companyTraceCoin
                  }}元</span
                >
              </p>
            </div>
            <div class="Content">
              <p class="title-p">支付方式：</p>
              <div class="Content-box">
                <p
                  class="Options"
                  v-for="(item, index) in payTypeArr"
                  :key="index"
                  :class="payType == item.id ? 'Select-Options' : ''"
                  @click="payType = item.id"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
            <div class="Content">
              <p class="title-p">应付款：</p>
              <div class="Content-box">
                <p style="color: red">{{ TotalAmount }}元</p>
              </div>
            </div>
          </div>

          <div style="text-align: center; font-size: 12px; color: #999; margin: 20px 0">
            付费即表示同意 <span
              @click="handelAgreement('侦迹云增值服务协议')"
              style="color: #409eff ; cursor: pointer"
              >《侦迹云增值服务协议》</span
            >
          </div>

          <div
            style="display: flex; align-items: center; justify-content: center"
          >
            <el-button
              type="primary"
              style="margin-right: 80px"
              @click="handelCancel"
              >取消</el-button
            >
            <el-button type="primary" @click="handelConfirm">确认</el-button>
          </div>
        </div>
      </div>
      <div>
        <div class="box-title">
          <span>历史推广信息</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
        </div>
        <el-table
          :data="tableData"
          size="small"
          stripe
          :header-cell-style="{
            background: '#409eff ',
            textAlign: 'center',
            color: '#ffffff',
            padding: '3px',
            fontSize: '12px',
            fontWeight: '400',
            height: '45px',
            border: 0,
          }"
        >
          <el-table-column label="推广ID" align="center" width="180">
            <template slot-scope="scope"
              ><span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="mediaTypeName" align="center" label="推广方式">
          </el-table-column>
          <el-table-column
            prop="posterPlaceName"
            align="center"
            label="推广途径"
          >
          </el-table-column>
          <el-table-column
            prop="promotionNum"
            align="center"
            label="所购推广次数"
          >
            <template slot-scope="scope">
              {{ scope.row.promotionNum }}
            </template>
          </el-table-column>
          <el-table-column
            prop="promotionCount"
            align="center"
            label="已推广次数"
          >
            <template slot-scope="scope">{{
              scope.row.promotionCount
            }}</template>
          </el-table-column>
          <el-table-column
            prop="finishTime"
            align="center"
            label="完成推广时间"
            width="180"
          >
            <template slot-scope="scope">{{ scope.row.finishTime }}</template>
          </el-table-column>
          <el-table-column prop="buyTime" align="center" label="购买时间" width="180">
            <template slot-scope="scope">{{
              scope.row.buyTime
            }}</template></el-table-column
          >

          <el-table-column label="推广详情" align="center">
            <template slot-scope="scope">
              <span
                class="span-Operation"
                style="color: #409eff ;cursor: pointer;"
                width="180"
                @click="handelDetails(scope.row, 0)"
                >查看</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="posterStatusName" align="center" label="状态">
            <template slot-scope="scope">{{
              scope.row.posterStatusName
            }}</template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>

    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :payMethod="payMethod"
      :totalAmount="totalAmount"
      :orderId="orderId"
      :businessType="businessType"
      :queryType="'info'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
    <!-- 查看详情 -->
    <Check
      :VisibleCheck="VisibleCheck"
      :PromotionRow="PromotionRow"
      @handleCloseCheck="VisibleCheck = false"
    ></Check>
  </div>
</template>

<script>
import Check from "./components/Check.vue";
import {
  companyPosters, //公司广告列表
  getSysPosterPriceSetting, //获取广告价格，购买数量，最少购买次数配置
  calculateCompanyPosterPrice, //计算企业广告推广费用
  pay, //支付
} from "../../../../assets/api/firm/firmActivity";
import {
  selectCompanyWalletList, //企业钱包列表
} from "../../../../assets/api/firm/firmCenter";
import {
  queryCompanyPaySetting, //查询是否开通了支付密码
} from "../../../../assets/api/Agency/Enterprise";
// 引入分页组件
import paging from "../../../../components/paging.vue";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../firmCenter/ProxyService/Enterprise/Bookkeeping/components/IndexCom/VerificationPwd.vue"; //支付密码验证
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD, PAYMENT_METHODS } from "@/utils/paymentMethods";
export default {
  data() {
    return {
      loading1: false,
      VisibleCheck: false, //查看详情
      VisiblePwd: false, //支付密码验证
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择
      num: 0, //0可操作右侧内容 1只可操作提交订单部分
      routeName: "",

      isIndex: 0,
      options: [
        {
          value: 0,
          label: "WEB网站首页",
        },
        {
          value: 1,
          label: "APP首页",
        },
        {
          value: 2,
          label: "小程序首页",
        },
        {
          value: 3,
          label: "APP启动页",
        },
        {
          value: 4,
          label: "小程序启动页",
        },
      ],
      numList: [
        {
          id: 5,
          number: "其他",
        },
      ],
      textIndex: "",
      //分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //总数
      },
      // 列表数据
      tableData: [],
      ruleForm: {
        TXurl: "", //上传到腾讯云的地址
        route: "", //途经
        quantity: "", //输入数量
      }, // 注销数据绑定
      rules: {
        // 规则未完善
        // valNumber: [
        //   {
        //     // 改为箭头函数，this 指向 Vue 实例
        //     validator: (rule, value, callback) => {
        //       if (!value) return callback();
        //       const num = Number(value);
        //       if (isNaN(num) || !Number.isInteger(num) || num < 1) {
        //         return callback(new Error("只能输入0以上的正整数"));
        //       }
        //       // 现在可以正确访问 this.minPurchase 和 this.maxPurchase
        //       if (num < this.minPurchase || num > this.maxPurchase) {
        //         return callback(
        //           new Error(
        //             `请输入${this.minPurchase}~${this.maxPurchase}之间的正整数`
        //           )
        //         );
        //       }
        //       callback();
        //     },
        //     trigger: ["blur", "change"],
        //   },
        // ],

        TXurl: [
          {
            required: true,
            message: "请上传海报/视频",
            trigger: ["blur", "change"],
          },
        ],
        route: [
          {
            required: true,
            message: "请选择推广途径",
            trigger: ["blur", "change"],
          },
        ],
        quantity: [
          {
            required: true,
            message: "推广次数不能为空",
            trigger: ["blur", "change"],
          },
          {
            // 改为箭头函数，this 指向 Vue 实例
            validator: (rule, value, callback) => {
              if (!value) return callback();
              const num = Number(value);
              if (isNaN(num) || !Number.isInteger(num) || num < 1) {
                return callback(new Error("只能输入0以上的正整数"));
              }
              // 现在可以正确访问 this.minPurchase 和 this.maxPurchase
              if (num < this.leastBuyNumber) {
                return callback(
                  new Error(`请输入${this.leastBuyNumber}以上的正整数`)
                );
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
      },

      leastBuyNumber: 1,

      checked: false, //是否使用侦迹币抵扣
      dataObj: {},
      TotalAmount: 0, //金额
      PaymentPassword: false, //是否开通了支付密码·

      alipayForm: ``, //支付弹窗二维码
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      VisiblePayment: false, //扫码支付弹窗
      PromotionRow: {}, // 推广详情
      accountStatus: "", //侦迹币状态
    };
  },
  created() {
    this.routeName = this.$route.name;
    this.companyPosters();
    this.getSysPosterPriceSetting();
    this.queryCompanyPaySetting();
    this.selectCompanyWalletList();
  },
  components: { paging, VerificationPwd, CommonPayment, Check },
  mounted() {},
  methods: {
    // APP启动页 / 小程序启动页 不支持视频
    isStartupPage(route) {
      return route === 3 || route === 4;
    },
    tipStartupNoVideo() {
      this.$tool.PromptBox(
        "error",
        "APP启动页、小程序启动页不支持上传视频，请使用海报推广（建议比例16:9）"
      );
    },
    handleMediaTypeChange(type) {
      if (type === 1 && this.isStartupPage(this.ruleForm.route)) {
        this.tipStartupNoVideo();
        return;
      }
      this.isIndex = type;
      this.ruleForm.TXurl = "";
    },
    handleRouteChange(val) {
      if (this.isStartupPage(val) && this.isIndex === 1) {
        this.tipStartupNoVideo();
        this.isIndex = 0;
        this.ruleForm.TXurl = "";
      }
    },
    //协议跳转
    handelAgreement(agreementName) {
      if (agreementName) {
        const route = this.$router.resolve({
          path: "/AboutUs/Express",
          query: { name: agreementName },
        });
        window.open(route.href, '_blank');
      }
    },
    // 查询侦迹币是否冻结
    selectCompanyWalletList() {
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id, // 公司id
        },
      };
      selectCompanyWalletList(data).then((res) => {
        if (res.code == 0) {
          // 状态
          this.accountStatus = res.data.accountStatus;
        }
      });
    },
    // 查看推广详情
    handelDetails(row) {
      this.PromotionRow = row;
      this.VisibleCheck = true;
    },
    //付款成功
    handleSuccess() {
      this.num = 0;
      this.ruleForm = {
        TXurl: "", //上传到腾讯云的地址
        route: "", //途经
        quantity: "", //输入数量
      }; // 注销数据绑定
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 100);
      this.VisiblePayment = false;
      this.companyPosters();
      // this.getSysPosterPriceSetting();
      // this.$router.push("/PaymentCompleted");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 支付密码确认成功提交
    handleUnderstandPwd(pwd) {
      // pwd支付密码
      var data = {
        data: {
          businessType: "COMPANY_POSTER_BUY",
          payMethod:
            this.payType == "" || this.TotalAmount == 0
              ? PAYMENT_METHODS.TRACE_COIN
              : this.payType, //
          password: pwd,
          businessInfo: {
            mediaType: this.isIndex,
            mediaPath: this.ruleForm.TXurl,
            posterPlace: this.ruleForm.route,
            count: this.dataObj.count,
            useTraceCoin: this.checked == false ? 0 : 1,
          },
        },
      };
      pay(data).then((res) => {
        if (res.code == 0) {
          this.VisiblePwd = false;
          if (this.payType == "" || this.TotalAmount == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.companyPosters();
            this.ruleForm = {
              TXurl: "", //上传到腾讯云的地址
              route: "", //途经
              quantity: "", //输入数量
            }; // 注销数据绑定
            this.dataObj = {};
            this.num = 0;
            this.checked = false;
            this.TotalAmount = 0;
            this.isIndex = 0;
            this.textIndex = this.numList[0].number;
            setTimeout(() => {
              this.$refs.ruleForm.clearValidate();
            }, 100);
          } else {
            this.alipayForm = res.data.payPage;
            this.totalAmount = res.data.totalAmount;
            this.businessType = res.data.businessType;
            this.payMethod = res.data.payMethod;
            this.orderId = res.data.orderId;

            this.VisiblePayment = true;
          }
        } else {
          this.VisiblePwd = false;
        }
      });
    },
    // 查询是否开通支付密码
    queryCompanyPaySetting() {
      queryCompanyPaySetting().then((res) => {
        if (res.code == 0) {
          this.PaymentPassword = res.data;
        }
      });
    },
    // 取消付款
    handelCancel() {
      this.num = 0;
    },
    //确认
    handelConfirm() {
      if (!this.$checkAction()) return;
      if (this.TotalAmount > 0 && this.payType == "") {
        this.$tool.PromptBox("error", "请选择支付方式");
      } else {
        // 支付提交
        if (this.PaymentPassword == false) {
          //没有开启支付密码验证直接弹支付二维码
          this.handleUnderstandPwd();
        } else {
          // 支付密码验证
          this.VisiblePwd = true;
        }
      }
    },
    // 计算需付款
    handelChange() {
      console.log(this.checked);
      const num = this.$tool.num;
      const amount = num.toNumber(this.dataObj.amount);
      const coin = num.toNumber(this.dataObj.companyTraceCoin);
      if (this.checked == true) {
        if (coin >= amount) {
          this.TotalAmount = 0;
        } else if (amount > coin) {
          this.TotalAmount = num.sub(amount, coin);
        }
      } else {
        this.TotalAmount = amount;
      }
    },
    //获取广告价格，购买数量，最少购买次数配置
    getSysPosterPriceSetting() {
      getSysPosterPriceSetting().then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.textIndex = res.data.numberSettingList[0].number;
          this.numList = [...res.data.numberSettingList, ...this.numList];
          this.leastBuyNumber = res.data.leastBuyNumber;
        }
      });
    },
    // 计算价格
    handelPrice(ruleForm) {
      if (!this.$checkAction()) return;
      if (this.isIndex === 1 && this.isStartupPage(this.ruleForm.route)) {
        this.tipStartupNoVideo();
        return;
      }
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          var data = {
            data: {
              mediaType: this.isIndex, //推广类型 0图片 1视频
              posterPlace: this.ruleForm.route, //位置
              count:
                this.textIndex == "其他"
                  ? this.ruleForm.quantity
                  : this.textIndex, //次数
            },
          };
          calculateCompanyPosterPrice(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox(
                "success",
                "价格计算成功请在付款信息表单完成订单提交"
              );
              this.num = 1;
              this.dataObj = res.data;
              this.TotalAmount = res.data.amount;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 上传
    clickFile() {
      if (this.isIndex === 1 && this.isStartupPage(this.ruleForm.route)) {
        this.tipStartupNoVideo();
        return;
      }
      const input = document.querySelector("#file");
      input.click();
    },
    // 调用上传文件/图片封装的js
    async onFileChange(event, opt, callback) {
      this.loading1 = true;
      var file = event.target.files[0] || event.dataTransfer.files[0];
      if (!file) {
        this.loading1 = false;
        return;
      }

      if (this.isIndex === 1 && this.isStartupPage(this.ruleForm.route)) {
        this.loading1 = false;
        this.$refs.clearFile.value = "";
        this.tipStartupNoVideo();
        return;
      }

      var fileSuffix1 = file.name;
      var fileArr = fileSuffix1.split(".");
      var fileSuffix = fileArr[fileArr.length - 1].toLowerCase(); // 统一转小写
      const fileSize = file.size; // ✅ 正确获取文件大小

      if (this.isIndex == 0) {
        // 图片上传
        var MAX_SIZE_10MB = 10 * 1024 * 1024;
        const allowTypes = ["png", "jpg"];

        // ✅ 正确判断：格式 + 大小
        if (allowTypes.includes(fileSuffix) && fileSize <= MAX_SIZE_10MB) {
          try {
            let URL = window.URL || window.webkitURL;
            var arr = await this.$tool.onFileChangeNew(event, opt, callback);
            if (arr.code == 0) {
              this.loading1 = false;
              this.imgSrc = URL.createObjectURL(file);
              this.ruleForm.TXurl = arr.TXurl;
              this.$refs.ruleForm.validateField("TXurl");
            }
          } catch (e) {}
        } else {
          this.loading1 = false;
          this.$tool.PromptBox("error", "请上传png/jpg格式图片且大小在10MB以内");
        }
      } else {
        // 视频上传
        var MAX_SIZE_100MB = 100 * 1024 * 1024;
        const allowVideoTypes = ["mp4", "avi", "wmv", "mpeg", "mkv"];

        if (
          allowVideoTypes.includes(fileSuffix) &&
          fileSize <= MAX_SIZE_100MB
        ) {
          try {
            let URL = window.URL || window.webkitURL;
            var arr = await this.$tool.onFileChangeNew(
              event,
              Object.assign({}, opt, { maxSizeMB: 100 }),
              callback
            );
            if (arr.code == 0) {
              this.loading1 = false;
              this.imgSrc = URL.createObjectURL(file);
              this.ruleForm.TXurl = arr.TXurl;
              this.$refs.ruleForm.validateField("TXurl");
            }
          } catch (e) {}
        } else {
          this.loading1 = false;
          this.$tool.PromptBox(
            "error",
            "请上传MP4/AVI/WMV/MPEG格式视频且大小在100MB以内"
          );
        }
      }
      this.$refs.clearFile.value = ""; // 清空文件
    },
    // -----------------------公司广告列表-------------
    async companyPosters() {
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
        },
      };
      // 公司广告列表
      companyPosters(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    textChange(item, index) {
      this.textIndex = item.number;
    },
    // 分页
    handleCurrentChange(val, pagingObj) {
      this.pagingObj.currentPage = val;
      console.log(this.pagingObj.currentPage, this.pagingObj.pageSize);
      this.companyPosters();
    },
  },
};
</script>
<style lang="less" scoped>
.Content {
  width: 100%;
  min-height: 35px;
  line-height: 35px;
  display: flex;
  font-size: 14px;
  margin-bottom: 25px;
  .Options {
    width: 85px;
    height: 33px;
    line-height: 35px;
    background: #ffffff;
    border: 1px solid #409eff ;
    border-radius: 5px;
    font-size: 12px;
    color: #409eff ;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
  }
  .Select-Options {
    background: rgba(97, 144, 232, 0.27);
      cursor: pointer;
}
  .title-p {
    min-width: 110px;
    color: #333333;
    text-align: right;
  }
  .Content-box {
    display: flex;
    flex-wrap: wrap;
    .span {
      font-size: 12px;
      color: #999999;
      line-height: 18px;
      margin-top: 10px;
    }
  }
}
/deep/.el-checkbox__label {
  color: black !important;
  font-size: 16px;
}
.is-disabled {
  pointer-events: none;
  opacity: 0.6;
  user-select: none;
}
/* 初始化蓝色边框 */
/deep/ .el-form-item .el-input__inner {
  border-color: #409eff ;
}
/* 验证失败红色边框 */
/deep/ .el-form-item.is-error .el-input__inner {
  border-color: #fe574a;
}
/deep/ .el-form-item.is-error .flex-box {
  border-color: #fe574a !important;
}
// /deep/  .el-input__inner{
//     border: 1px solid #409eff  !important;
// }
.main {
  .box-con {
    width: 100%;
    min-height: 700px;
    box-sizing: border-box;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    padding: 30px;
    position: relative;

    .left {
      width: 680px;
      height: 600px;
      background: #ffffff;
      box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
      border-radius: 20px;
      padding: 30px;
      box-sizing: border-box;

      .change-box {
        width: 210px;
        height: 50px;
        background: #eeeeee;
        border: 1px solid #999999;
        border-radius: 10px 10px 0px 0px;
        text-align: center;
        line-height: 50px;
        font-size: 12px;
        cursor: pointer;
        box-sizing: border-box;
      }

      .change-box-active {
        background: rgba(97, 144, 232, 0.2);
        border: 1px solid #409eff ;
        color: #409eff ;
      }

      .upload-box {
        width: 420px;
        height: 200px;
        background: #ffffff;
        border: 1px solid #409eff ;
        border-top: 0;
        border-radius: 0px 0px 5px 5px;
        box-sizing: border-box;
        padding-top: 1px;
        .container {
          width: 190px;
          height: 120px;
          border: 1px dashed #409eff ;
          margin: 0 auto;
          margin-top: 20px;
          display: flex;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          #file {
            display: none;
          }
          #file1 {
            display: none;
          }
          input {
            border: none;
            box-shadow: none;
            outline: none;
            background-color: transparent;
            width: 100%;
            text-align: center;
            color: #409eff ;
            // margin-top: 40px;
            margin: auto 0;
          cursor: pointer;
          font-size: 26px;
          }
        }
      }

      .text-box {
        width: 90px;
        height: 30px;
        background: #ffffff;
        border: 1px solid #409eff ;
        border-radius: 5px;
        color: #409eff ;
        font-size: 12px;
        cursor: pointer;
        line-height: 30px;
        box-sizing: border-box;
        text-align: center;
        margin-top: 10px;
      }

      .text-box-active {
        background: rgba(97, 144, 232, 0.27);
      }
    }

    .right {
      width: 430px;
      height: 600px;
      background: #ffffff;
      box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
      border-radius: 20px;
      padding: 30px;
      box-sizing: border-box;
    }
  }
}

/deep/.el-form-item__label {
  font-size: 14px;
}

/deep/.el-upload-dragger {
  border-color: #409eff ;
  width: 175px;
  height: 105px;
}

.box-title {
  position: relative;
  margin-bottom: 20px;
  margin-top: 15px;

  span {
    font-size: 20px;
    font-weight: 500;
    color: #333;
  }

  img {
    position: absolute;
    bottom: 0px;
    left: 18px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
